import { ComponentType, SVGProps } from "react";
import {
  Megaphone,
  LayoutDashboard,
  Users,
  Tag,
  Mail,
  FileText,
  GitBranch,
  Layers,
  LucideProps,
  TrendingUp,
  Lightbulb,
  Share2,
  Coins,
  Receipt,
  ShoppingBag,
  Cpu,
  Database,
  BookOpen,
  ClipboardList,
  Headphones,
  Settings2,
  ScrollText,
  FolderUp,
  FileCode,
  FileSpreadsheet,
  FileUp,
  ShieldCheck,
  Package,
  ShoppingCart,
  Building2,
  Globe,
  PackagePlus,
  Archive,
  UserPlus,
  MapPin,
  FileDown,
  PackageCheck,
  Ticket,
  FolderTree,
  Award,
  Image,
  SlidersHorizontal,
  Building,
  Truck,
  UserRound,
  Handshake,
  User,
  UsersRound,
  CreditCard,
  Presentation,
  Images,
  Crown,
  PenLine,
  UserPen,
  FolderOpen,
  ListTodo,
  ListFilter,
  Upload,
  MessageCircle,
  ContactRound,
  LayoutList,
  Store,
  Map,
  Star,
  FolderInput,
  Bot,
  Sparkles,
  ScrollText as ScrollTextLara,
  FlaskConical,
  Newspaper,
  ScanSearch,
} from "lucide-react";

// Menu icons
import { ReactComponent as AdminIcon } from "~assets/menu/admin.svg";
import { ReactComponent as AuthorIcon } from "~assets/menu/author.svg";
import { ReactComponent as BannerIcon } from "~assets/menu/banner.svg";
import { ReactComponent as BlogIcon } from "~assets/menu/blog.svg";
import { ReactComponent as BrandIcon } from "~assets/menu/brand.svg";
import { ReactComponent as CampaignIcon } from "~assets/menu/campaign.svg";
import { ReactComponent as CategoriesIcon } from "~assets/menu/categories.svg";
import { ReactComponent as ClientIcon } from "~assets/menu/cliente-ico.svg";
import { ReactComponent as CouponIcon } from "~assets/menu/coupon.svg";
import { ReactComponent as DindinIcon } from "~assets/menu/dindin.svg";
import { ReactComponent as EcommerceIcon } from "~assets/menu/ecommerce.svg";
import { ReactComponent as FinancialIcon } from "~assets/menu/financial.svg";
import { ReactComponent as DashboardIcon } from "~assets/menu/google_analytics.svg";
import { ReactComponent as HighlightIcon } from "~assets/menu/highlight.svg";
import { ReactComponent as IdeaIcon } from "~assets/menu/ideia.svg";
import { ReactComponent as ImportingIcon } from "~assets/menu/importing.svg";
import { ReactComponent as PostIcon } from "~assets/menu/post.svg";
import { ReactComponent as PostCategoryIcon } from "~assets/menu/post_category.svg";
import { ReactComponent as ProductIcon } from "~assets/menu/product.svg";
import { ReactComponent as RegisterIcon } from "~assets/menu/register.svg";
import { ReactComponent as SupplierIcon } from "~assets/menu/representada.svg";
import { ReactComponent as SalesIcon } from "~assets/menu/sales.svg";
import { ReactComponent as ChartIcon } from "~assets/menu/sales_report.svg";
import { ReactComponent as SupportIcon } from "~assets/menu/support.svg";
import { ReactComponent as SupplierAltIcon } from "~assets/menu/supplier.svg";
import { ReactComponent as TruckIcon } from "~assets/menu/truck-ico.svg";
import { ReactComponent as VcardIcon } from "~assets/menu/vcard.svg";
import { ReactComponent as SettingsIcon } from "~assets/menu/website_info.svg";
import { ReactComponent as RocketIcon } from "~assets/menu/rocket.svg";

const ICON_MAP: Record<string, ComponentType<SVGProps<SVGSVGElement>>> = {
  dashboard: DashboardIcon,
  marketing: CampaignIcon,
  chart: ChartIcon,
  dindin: DindinIcon,
  categories: CategoriesIcon,
  idea: IdeaIcon,
  register: RegisterIcon,
  blog: BlogIcon,
  ecommerce: EcommerceIcon,
  financial: FinancialIcon,
  support: SupportIcon,
  settings: SettingsIcon,
  users: ClientIcon,
  campaign: CampaignIcon,
  template: PostIcon,
  workflow: DashboardIcon,
  truck: TruckIcon,
  supplier: SupplierIcon,
  supplierAlt: SupplierAltIcon,
  vcard: VcardIcon,
  banner: BannerIcon,
  admin: AdminIcon,
  post: PostIcon,
  author: AuthorIcon,
  postCategory: PostCategoryIcon,
  coupon: CouponIcon,
  sales: SalesIcon,
  product: ProductIcon,
  import: ImportingIcon,
  brand: BrandIcon,
  highlight: HighlightIcon,
  rocket: RocketIcon,
} as const;

const LUCIDE_ICON_MAP: Record<string, ComponentType<LucideProps>> = {
  "lu-marketing": Megaphone,
  "lu-dashboard": LayoutDashboard,
  "lu-segments": Users,
  "lu-tags": Tag,
  "lu-campaigns": Mail,
  "lu-templates": FileText,
  "lu-workflows": GitBranch,
  "lu-buckets": Layers,
  "lu-newsletter": Newspaper,

  // Main modules
  "lu-comercial": TrendingUp,
  "lu-oportunidades": Lightbulb,
  "lu-distribuicao": Share2,
  "lu-dindin": Coins,
  "lu-financeiro": Receipt,
  "lu-loja": ShoppingBag,
  "lu-motores": Cpu,
  "lu-cadastro": Database,
  "lu-blog": BookOpen,
  "lu-tarefas": ClipboardList,
  "lu-suporte": Headphones,
  "lu-config": Settings2,

  // Financeiro submenus
  "lu-titulos": ScrollText,
  "lu-folder-up": FolderUp,
  "lu-file-code": FileCode,
  "lu-file-spreadsheet": FileSpreadsheet,
  "lu-file-up": FileUp,
  "lu-shield-check": ShieldCheck,

  // Loja Online submenus
  "lu-package": Package,
  "lu-shopping-cart": ShoppingCart,
  "lu-building": Building,
  "lu-globe": Globe,
  "lu-package-plus": PackagePlus,
  "lu-archive": Archive,
  "lu-user-plus": UserPlus,
  "lu-map-pin": MapPin,
  "lu-file-down": FileDown,
  "lu-package-check": PackageCheck,
  "lu-ticket": Ticket,
  "lu-folder-tree": FolderTree,
  "lu-award": Award,
  "lu-image": Image,
  "lu-sliders": SlidersHorizontal,

  // Motores / shared
  "lu-building2": Building2,
  "lu-truck": Truck,

  // Cadastro submenus
  "lu-user-round": UserRound,
  "lu-handshake": Handshake,
  "lu-user": User,
  "lu-users-round": UsersRound,
  "lu-credit-card": CreditCard,
  "lu-presentation": Presentation,
  "lu-images": Images,
  "lu-crown": Crown,

  // Blog submenus
  "lu-pen-line": PenLine,
  "lu-user-pen": UserPen,
  "lu-folder-open": FolderOpen,

  // Tarefas submenus
  "lu-list-todo": ListTodo,
  "lu-list-filter": ListFilter,
  "lu-upload": Upload,

  // Suporte submenus
  "lu-message-circle": MessageCircle,

  // Gerenciador de Chat
  "lu-contact-round": ContactRound,
  "lu-layout-list": LayoutList,

  // Configuracao submenus
  "lu-store": Store,
  "lu-map": Map,

  // Additional icons for Loja Online
  "lu-star": Star,
  "lu-folder-input": FolderInput,

  // Lara IA submenus
  "lu-bot": Bot,
  "lu-sparkles": Sparkles,
  "lu-prompt": ScrollTextLara,
  "lu-flask": FlaskConical,
  "lu-scan-search": ScanSearch,
} as const;

export type IconName = keyof typeof ICON_MAP | keyof typeof LUCIDE_ICON_MAP;

interface IconProps {
  name: IconName;
  size?: "sm" | "md" | "lg";
  className?: string;
  "aria-hidden"?: boolean;
}

const SIZES = {
  sm: "1rem",
  md: "1.25rem",
  lg: "1.5rem",
} as const;

export function Icon({ name, size = "md", className, ...props }: IconProps) {
  const IconComponent = ICON_MAP[name];

  if (IconComponent) {
    return (
      <IconComponent
        className={className}
        style={{
          width: SIZES[size],
          height: SIZES[size],
          flexShrink: 0,
        }}
        aria-hidden={props["aria-hidden"] ?? true}
        {...props}
      />
    );
  }

  const LucideComponent = LUCIDE_ICON_MAP[name];

  if (LucideComponent) {
    return (
      <LucideComponent
        className={className}
        style={{ width: SIZES[size], height: SIZES[size], flexShrink: 0 }}
        aria-hidden={props["aria-hidden"] ?? true}
        strokeWidth={1.75}
      />
    );
  }

  console.warn(`Icon "${name}" not found in ICON_MAP or LUCIDE_ICON_MAP`);
  return null;
}

export { ICON_MAP, LUCIDE_ICON_MAP };
